import { Link } from "react-router-dom";
import { Chapter, MaskedLines, Reveal } from "@/components/aklive/motion";
import { PlaceholderBlock } from "@/components/aklive/PlaceholderBlock";

export const FinalCTA = () => (
  <section className="py-24 md:py-40" data-testid="final-cta-section">
    <div className="container-ak">
      <Chapter index="08" label="Start" />
      <div className="grid items-end gap-14 lg:grid-cols-12 lg:gap-8">
        <div className="lg:col-span-7">
          <h2 className="font-display text-5xl font-bold leading-[0.98] tracking-[-0.02em] text-ink sm:text-6xl lg:text-7xl">
            <MaskedLines
              lines={[
                "Built for what",
                <span key="l2">
                  comes next<span className="text-ember">.</span>
                </span>,
              ]}
            />
          </h2>
          <Reveal delay={0.25} className="mt-10 flex flex-col gap-4 sm:flex-row md:mt-14">
            <Link to="/contact" data-testid="cta-start-project-btn" className="btn-primary h-14 px-8 text-base">
              Start a Project
            </Link>
            <Link to="/work" data-testid="cta-explore-work-btn" className="btn-secondary h-14 px-8 text-base">
              Explore Our Work
            </Link>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="lg:col-span-5">
          <PlaceholderBlock label="[PROJECT IMAGE — LANDSCAPE]" ratio="4 / 3" />
        </Reveal>
      </div>
    </div>
  </section>
);
